import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

interface ContactFormProps {
  contactForm: any;
  setContactForm: (form: any) => void;
  isContactSubmitting: boolean;
  contactError: string | null;
  contactSuccess: boolean;
  handleContactSubmit: (e: React.FormEvent) => void;
}

const ContactForm: React.FC<ContactFormProps> = ({ contactForm, setContactForm, isContactSubmitting, contactError, contactSuccess, handleContactSubmit }) => {
  const { t } = useTranslation();
  return (
    <section id="contact" className="py-20 bg-black/30 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-8">
            {t('contact.title')}
          </h2>
          <form onSubmit={handleContactSubmit} className="space-y-8">
            <div className="space-y-4">
              <input
                type="text"
                className="w-full px-4 py-3 rounded-lg bg-white/50 dark:bg-black/50 backdrop-blur-sm border border-gray-200 dark:border-gray-800 focus:ring-2 focus:ring-accent focus:border-transparent transition-colors"
                placeholder={t('contact.namePlaceholder')}
                value={contactForm.name}
                onChange={e => setContactForm((prev: any) => ({ ...prev, name: e.target.value }))}
                required
              />
            </div>
            <div className="space-y-4">
              <input
                type="email"
                className="w-full px-4 py-3 rounded-lg bg-white/50 dark:bg-black/50 backdrop-blur-sm border border-gray-200 dark:border-gray-800 focus:ring-2 focus:ring-accent focus:border-transparent transition-colors"
                placeholder={t('contact.emailPlaceholder')}
                value={contactForm.email}
                onChange={e => setContactForm((prev: any) => ({ ...prev, email: e.target.value }))}
                required
              />
            </div>
            <div className="space-y-4">
              <textarea
                rows={6}
                className="w-full px-4 py-3 rounded-lg bg-white/50 dark:bg-black/50 backdrop-blur-sm border border-gray-200 dark:border-gray-800 focus:ring-2 focus:ring-accent focus:border-transparent transition-colors resize-none"
                placeholder={t('contact.messagePlaceholder')}
                value={contactForm.message}
                onChange={e => setContactForm((prev: any) => ({ ...prev, message: e.target.value }))}
                required
              ></textarea>
            </div>
            {contactError && (
              <div className="text-red-500 text-center">
                {contactError}
              </div>
            )}
            {contactSuccess && (
              <div className="text-green-500 text-center">
                {t('contact.successMessage')}
              </div>
            )}
            <div className="text-center">
              <motion.button
                type="submit"
                disabled={isContactSubmitting}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-accent text-white px-8 py-3 rounded-full text-lg font-medium hover:bg-opacity-90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isContactSubmitting ? (
                  t('contact.submitting')
                ) : (
                  t('contact.submit')
                )}
              </motion.button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
